import { useSelector } from 'react-redux';
import { getPrices, getRefundAutoMode, getTicketPrice } from '../model';
import { useRefundInsurancePrices } from './useRefundInsurancePrices';

export const useCreateRefundPrice = () => {
	const prices = useSelector(getPrices);
	const ticketPrice = useSelector(getTicketPrice);
	const isAutoMode = useSelector(getRefundAutoMode);

	const insurancePrices = useRefundInsurancePrices();

	const showPrices = prices && isAutoMode;

	return {
		prices,
		showPrices,
		ticketPrice,
		additionalPrices: insurancePrices
	};
};
